






































import type {Photo} from "../../types/photo/Photo";
import type {ModuleSettings} from "../../types/photo/ModuleSettings";

import Vue from "vue";
import EhrNavigation from "../interface/EhrNavigation.vue";
import SectionCard from "../interface/SectionCard.vue";
import {photoRepository} from "../repositories/photoRepository";
import PhotoChangeRequestForm from "./PhotoChangeRequestForm.vue";
import * as SwalUtils from "../utils/SwalUtils.js";

interface Data {
    loading: boolean;
    moduleSettings: ModuleSettings;
    currentPhoto?: Photo;
    changeRequest?: Photo;
}

export default Vue.extend({
    name: "photo-module",
    components: { EhrNavigation, SectionCard, PhotoChangeRequestForm },
    data(): Data {
        return {
            loading: false,
            moduleSettings: {} as ModuleSettings,
            currentPhoto: undefined,
            changeRequest: undefined
        }
    },
    created() {
      this.getModuleSettings();
      this.getPhoto();
    },
    methods: {
        async getModuleSettings() {
          this.moduleSettings = await photoRepository.moduleSettings();
        },
        async getPhoto() {
            this.loading = true;
            const {currentPhoto, changeRequest} = await photoRepository.photo();
            this.loading = false;
            this.currentPhoto = currentPhoto;
            this.changeRequest = changeRequest;
        },
        async onCancelChangeRequest() {
            if (this.changeRequest?.pPhoto === undefined) return;
            const {pPhoto} = this.changeRequest;
            try {
                await photoRepository.deletePhotoChangeReq(pPhoto);
            } catch (error) {
                await SwalUtils.DisplayErrorToast("Er is een fout opgetreden. Vernieuw het scherm en probeer opnieuw.");
            }
            await SwalUtils.DisplaySuccessToast("De aanvraag voor een nieuwe foto werd succesvol geannuleerd.");
            await this.getPhoto();
        },
        async onUpload() {
            await this.getPhoto();
        }
    }
});
